import { call, put, select } from 'redux-saga/effects';

import { createLineRequest, deleteLineRequest, updateLineRequest } from '../requests';
import { lineByIdSelector, nextLinePositionSelector, pathSelector } from '../../../selectors';
import { createLine, deleteLine, updateLine } from '../../../actions';
import { createLocalId } from '../../../utils/local-id';

export function* createLineService(siteId, data) {
  const nextData = {
    ...data,
    position: yield select(nextLinePositionSelector, siteId),
  };

  const localId = yield call(createLocalId);

  yield put(
    createLine({
      ...nextData,
      siteId,
      id: localId,
    }),
  );

  yield call(createLineRequest, siteId, localId, nextData);
}

export function* createLineInCurrentSiteService(data) {
  const { siteId } = yield select(pathSelector);
  yield call(createLineService, siteId, data);
}

export function* updateLineService(id, data) {
  yield put(updateLine(id, data));
  yield call(updateLineRequest, id, data);
}

export function* moveLineService(id, index) {
  const { siteId } = yield select(lineByIdSelector, id);
  const position = yield select(nextLinePositionSelector, siteId, index, id);

  yield call(updateLineService, id, {
    position,
  });
}

export function* deleteLineService(id) {
  yield put(deleteLine(id));
  yield call(deleteLineRequest, id);
}
